import colors from "../theme";
export const switchSx = {
  ml: 6,
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: colors.primary,
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: colors.primary,
  },
  "& .MuiSwitch-track": {
    backgroundColor: "lightgrey",
  },
};
